import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';

export const selectHasDishwasher = createSelector(selectJsonQuery, jsonQuery => getTermValue('dish_washer')(jsonQuery));
